export default __webpack_public_path__ + "static/media/tpaita1.0e3b8458.webp";